import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export interface CalcFieldProps {
  /** DOM id (namespaced so multiple calculators can coexist on one page). */
  domId: string;
  label: string;
  placeholder?: string;
  value: string;
  min?: number;
  onChange: (value: string) => void;
}

/** A single labeled numeric input used by the percentage calculators. */
export function CalcField({
  domId,
  label,
  placeholder,
  value,
  min,
  onChange,
}: CalcFieldProps) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={domId} className="text-muted-foreground">
        {label}
      </Label>
      <Input
        id={domId}
        type="number"
        inputMode="decimal"
        placeholder={placeholder}
        value={value}
        min={min}
        onChange={(e) => onChange(e.target.value)}
        // White field with dark text (both themes) — scoped to this tool.
        className="border-black/15 bg-white text-neutral-900 placeholder:text-neutral-500 hover:border-black/25 dark:border-black/15 dark:bg-white dark:text-neutral-900 dark:placeholder:text-neutral-500"
      />
    </div>
  );
}
